/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createArrayNode } from '../../factoriesNumber.js';
export var ArrayNodeDependencies = {
  NodeDependencies,
  createArrayNode
};